import { TableCell, TableRow } from "@mui/material";
import styled from "styled-components";

export const PartInfo = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 100px minmax(240px, 1fr);
	justify-content: flex-start;
`;
export const Info = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr;
	-webkit-box-pack: start;
	justify-content: flex-start;
	-webkit-box-align: center;
	align-items: center;
	gap: 0.4rem;
	padding: 0.2rem 0px;
	cursor: pointer;
	transition: background-color 0.3s;
`;
export const RowPart = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr;
	justify-content: flex-start;
	align-items: center;
	gap: 0.4rem;
	padding: 0.2rem 0;
	cursor: pointer;
	transition: background-color 0.3s;

	&:hover {
		background-color: ${({ theme }) => theme.grayLight};
	}

	.MuiFormControl-root {
		input.customInputHeight {
			height: 15px;
			border: 1px solid rgb(204, 204, 204);
			border-radius: 10px;
		}
	}

	.customBorder .MuiAutocomplete-inputRoot {
		height: 48px;
		border: 1px solid rgb(204, 204, 204);
		border-radius: 10px;
	}
	.customBorder.customBorder.customBorder.MuiInputBase-root {
		height: 48px;
		input {
			text-align: left;
			padding-left: 12px;
			font-size: 1.1em;
		}
	}
	.customBorder.MuiFormControl-root.MuiTextField-root .MuiInputBase-root.MuiFilledInput-root {
		height: 48px;
		border: 1px solid rgb(204, 204, 204);
		border-radius: 10px;
		background-color: white;
		input {
			border-radius: 10px;
		}
	}

	.customBorder .MuiFilledInput-underline:before {
		content: none;
	}

	.customBorder .MuiFilledInput-underline:after {
		content: none;
	}

	label .MuiInputLabel-asterisk {
		color: gray;
	}
	label.Mui-focused .MuiInputLabel-asterisk {
		color: #3f5ec9;
	}
	label .MuiInputLabel-asterisk.Mui-error.Mui-error.Mui-error {
		color: #f44336;
	}
`;
export const ImagePart = styled.img`
	width: 100%;
	max-width: 100px;
	height: 80px;
	object-fit: contain;
`;

export const StyledTableRow = styled(TableRow)`
	min-height: 80px;

	&&& .MuiTableCell-root {
		vertical-align: middle;
		padding-top: 12px;
		padding-bottom: 12px;
	}
`;

export const InputTableCell = styled(TableCell)`
	&&&&& {
		vertical-align: top;
		padding-top: 12px;
		padding-bottom: 12px;
		min-width: 150px;
	}
`;
